<template>
  <transition name="fade">
    <div style="position: absolute; left: 50%" class="whole">
      <div style="position: relative; left:-50%;">
        <p class="title">
          Signal deciphering failed, you should turn your device and navigate
          the ship landscape mode
        </p>
        <div class="spinner" style="position: absolute; left: 50%">
          <radar-spinner
            style="position: relative; left:-50%;"
            :animation-duration="1500"
            :size="size"
            :color="'#e0e2f4'"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { RadarSpinner } from "epic-spinners";
export default {
  name: "NotOriented",
  components: {
    RadarSpinner,
  },
  data() {
    return {
      size: null,
    };
  },
  created() {
    this.size = screen.height / 3;
  },
};
</script>

<style lang="scss" scoped>
.whole {
  position: absolute;
  top: 10vh;
}

.title {
  font-size: 1.5rem;
  text-align: center;
}

.spinner {
  margin-top: 5vh;
}
</style>
